var dayjs = require('dayjs');
var notificationsManager = require('@managers/notificationsManager');

export var hydrate_notifications_feed = feed => {
  return {
    type: 'HYDRATE_NOTIFICATIONS_FEED',
    feed: feed,
  };
};

export var set_notifications_feed_loading = (loadingType, isLoading) => {
  return {
    type: 'SET_NOTIFICATIONS_FEED_LOADING',
    loadingType: loadingType,
    isLoading: isLoading,
  };
};

export var set_notifications_feed = feed => {
  return {
    type: 'SET_NOTIFICATIONS_FEED',
    feed: feed,
  };
};

export var notifications_feed_fail = error => {
  return {
    type: 'NOTIFICATIONS_FEED_FAIL',
    error: error,
  };
};

export function fetchNotifications() {
  return notificationsManager.getNotificationsForUser(dayjs().unix());
}
